import { BomLineType } from 'bom/enums';
import { IPartBomItem } from 'partBoms/types';

export const getLineTypeCellValue = (partBomItem?: IPartBomItem) => {
  if (!partBomItem) {
    return null;
  }

  if (partBomItem.partArr?.wildcard) {
    return BomLineType.WILDCARD;
  }

  if (partBomItem.partArr?.verified) {
    return BomLineType.VERIFIED;
  }

  return BomLineType.UNVERIFIED;
};

export const aggFuncs = {
  sumQty: ({ values, rowNode: { rowGroupColumn } }) => {
    if (!rowGroupColumn || 'uom' !== rowGroupColumn.getColId()) {
      return null;
    }

    return values.reduce((acc: number, value: number) => acc + Number(value), 0);
  },
};
